import {AutomationPolicyConfig} from '@webmate-web-core/shared/types/browsersession';

export function hasAutomationPolicy(policy?: AutomationPolicyConfig | null): boolean {
    return !!policy && ((policy.presetSpecs?.length || 0) > 0 || (policy.policySpecs?.length || 0) > 0);
}

export function normalizeAutomationPolicy(policy?: AutomationPolicyConfig | null): AutomationPolicyConfig | undefined {
    return hasAutomationPolicy(policy) ? policy || undefined : undefined;
}

export function cloneAutomationPolicy(policy?: AutomationPolicyConfig | null): AutomationPolicyConfig | undefined {
    const normalizedPolicy = normalizeAutomationPolicy(policy);
    return normalizedPolicy ? JSON.parse(JSON.stringify(normalizedPolicy)) : undefined;
}

export function isManualOnlyMatchingSpec(matchingSpec?: any): boolean {
    return matchingSpec?.type === 'NoAutomaticMatchingSpec';
}
